import React from 'react';
import { useHistory } from 'react-router-dom';
import { useCurrentOrganisation } from '../../../../../app/CurrentOrganisationProvider';
import { Card, Section, Workspace } from '../../../../../design-system';
import { CreateLocationForm } from './CreateLocationForm';

export const CreateLocationView: React.FC = () => {
  const { push } = useHistory();

  const { organisation } = useCurrentOrganisation();
  const { slug } = organisation ?? { id: '', slug: '' };

  const goToLocations = React.useCallback(() => push(`/organisations/${slug}/locations`), [push, slug]);

  return (
    <Workspace>
      <Section
        title="Create location"
        description="Create a new location for your organisation. A location is a collection of one or more charge points."
      >
        <Card>
          <CreateLocationForm onExit={goToLocations} onCreated={goToLocations} />
        </Card>
      </Section>
    </Workspace>
  );
};
